"use strict";function memoize(e){var o={};return function(r){return void 0===o[r]&&(o[r]=e(r)),o[r]}}module.exports=memoize;